import {IconNameType} from '@toolify/server/src/enum/IconNameType'
import {MessageSeverityType} from '@toolify/client/src/modules/notifications/enum/MessageSeverityType'

export const MessageSeverityTypeToIconNameTypeMap: Record<MessageSeverityType, IconNameType> = {
  [MessageSeverityType.Success]: IconNameType.Check,
  [MessageSeverityType.Info]: IconNameType.InfoCircle,
  [MessageSeverityType.Warning]: IconNameType.TriangleExclamation,
  [MessageSeverityType.Error]: IconNameType.Xmark,
  [MessageSeverityType.Neutral]: IconNameType.Bell,
  [MessageSeverityType.Progress]: IconNameType.Spinner,
}
